import type { PayloadAction } from "@reduxjs/toolkit";
import { createSlice } from "@reduxjs/toolkit";
import { User } from "firebase/auth";

export interface authUserState {
  authUser: User | null;
}

const initialState: authUserState = {
  authUser: null,
};

export const authUserSlice = createSlice({
  name: "authUser",
  initialState,
  reducers: {
    setAuthUser: (state, action: PayloadAction<User>) => {
      state.authUser = action.payload;
    },
    resetAuthUserState: () => initialState,
  },
});

export const { setAuthUser, resetAuthUserState } = authUserSlice.actions;

export default authUserSlice.reducer;
